<div fxLayout="row wrap" fxLayoutGap="10px">
  <div fxFlex="100%">
    <h5>HM Portal Default Fields</h5>
    <p>Select which default fields to display in the HM Portal.</p>
  </div>
  
  <div fxFlex="32%" *ngFor="let field of defaultFields">
    <mat-checkbox [checked]="isDefaultFieldSelected(field)" (change)="toggleDefaultSelection(field, $event)">
      {{ field.value }}
    </mat-checkbox>
  </div>
  <div fxFlex="100%">
    <h5>HM Portal Custom Fields</h5>
    <p>Select which custom fields to display in the HM Portal.</p>
  </div>
  <div fxFlex="100%" *ngIf="customFields.length === 0">
    <p>No custom fields found.</p>
  </div>
  <div fxFlex="32%" *ngFor="let field of customFields" style="margin-bottom: 10px;">
    <mat-checkbox 
      [checked]="isFieldSelected(field)"
      (change)="toggleSelection(field, $event)">
      {{field.value}}
    </mat-checkbox>
  </div>
</div>
